import { HttpClient } from '@adapters/HttpClient';
import { CustomerReportResponse, CustomerExportResponse, CustomerFilters } from '../models';
import { extractCustomerReportRawMeta, normalizeCustomerPaginationMeta } from '../utils/paginationMeta';

export class CustomerReportApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getCustomerReport(filters?: CustomerFilters): Promise<CustomerReportResponse> {
    const params: Record<string, any> = {};

    if (filters) {
      // Pagination
      if (filters.page !== undefined) {
        params.page = filters.page;
      }
      if (filters.per_page !== undefined) {
        params.per_page = filters.per_page;
      }

      if (filters.sorting) {
        params['sorting[column]'] = filters.sorting.column;
        params['sorting[direction]'] = filters.sorting.direction;
      }

      if (filters.orders_prev_month_min !== undefined) {
        params.orders_prev_month_min = filters.orders_prev_month_min;
      }
      if (filters.orders_prev_month_max !== undefined) {
        params.orders_prev_month_max = filters.orders_prev_month_max;
      }
      if (filters.sale_type) {
        params.sale_type = filters.sale_type;
      }
      if (filters.country_id !== undefined) {
        params.country_id = filters.country_id;
      }
      if (filters.customer_origin && filters.customer_origin.length > 0) {
        params['customer_origin[]'] = filters.customer_origin;
      }
    }

    const response = await this.httpClient.get<CustomerReportResponse & Record<string, unknown>>(
      '/report/customer',
      params,
    );

    const data = Array.isArray(response.data) ? response.data : [];
    const page = filters?.page ?? 1;
    const perPage = filters?.per_page ?? 25;

    return {
      data,
      meta: normalizeCustomerPaginationMeta(extractCustomerReportRawMeta(response), data.length, page, perPage),
    };
  }

  async exportCustomerReport(filters?: CustomerFilters): Promise<CustomerExportResponse> {
    const params: Record<string, any> = {};

    if (filters) {
      if (filters.sorting) {
        params['sorting[column]'] = filters.sorting.column;
        params['sorting[direction]'] = filters.sorting.direction;
      }

      if (filters.orders_prev_month_min !== undefined) {
        params.orders_prev_month_min = filters.orders_prev_month_min;
      }
      if (filters.orders_prev_month_max !== undefined) {
        params.orders_prev_month_max = filters.orders_prev_month_max;
      }
      if (filters.sale_type) {
        params.sale_type = filters.sale_type;
      }
      if (filters.country_id !== undefined) {
        params.country_id = filters.country_id;
      }
      if (filters.customer_origin && filters.customer_origin.length > 0) {
        params['customer_origin[]'] = filters.customer_origin;
      }
    }

    const response = await this.httpClient.get<CustomerExportResponse>('/report/customer/export', params);

    return response;
  }
}
